import type React from 'react';

import { ChevronSortIcon } from '@vlabs/icons';
import type { TOption } from '@vlabs/uikit/types';

import { usePermissionTagsFilters } from '@vlabs/monokit/entities/permission-tags/filters';
import { DropdownSelect } from '@vlabs/monokit/shared/ui/dropdown-select';

import { useSortPermissionTagsTranslation } from './i18n';

type TPermissionTagsSortValue =
  | 'permission_tag_asc'
  | 'permission_tag_desc'
  | 'create_time_desc'
  | 'create_time_asc';

function getDropdownValue(sort?: string, order?: string): TPermissionTagsSortValue {
  if (sort === 'permission_tag' && order === 'desc') return 'permission_tag_desc';
  if (sort === 'create_time' && order === 'desc') return 'create_time_desc';
  if (sort === 'create_time' && order === 'asc') return 'create_time_asc';

  return 'permission_tag_asc';
}

function SortPermissionTagsDropdown(): React.JSX.Element {
  const { t } = useSortPermissionTagsTranslation();
  const { filters, updateFilters } = usePermissionTagsFilters();

  const options: TOption<TPermissionTagsSortValue>[] = [
    {
      label: t('permission_tag_asc') as unknown as string,
      value: 'permission_tag_asc',
    },
    {
      label: t('permission_tag_desc') as unknown as string,
      value: 'permission_tag_desc',
    },
    {
      label: t('create_time_desc') as unknown as string,
      value: 'create_time_desc',
    },
    {
      label: t('create_time_asc') as unknown as string,
      value: 'create_time_asc',
    },
  ];

  const value = getDropdownValue(filters.sort, filters.order);
  const selectedOption = options.find((option) => option.value === value);

  const onSelect = (nextValue: TPermissionTagsSortValue): void => {
    switch (nextValue) {
      case 'permission_tag_desc':
        updateFilters({ order: 'desc', sort: 'permission_tag' });
        return;
      case 'create_time_desc':
        updateFilters({ order: 'desc', sort: 'create_time' });
        return;
      case 'create_time_asc':
        updateFilters({ order: 'asc', sort: 'create_time' });
        return;
      default:
        updateFilters({ order: 'asc', sort: 'permission_tag' });
    }
  };

  return (
    <DropdownSelect
      icon={<ChevronSortIcon />}
      label={selectedOption?.label ?? ''}
      onSelect={onSelect}
      options={options}
      value={value}
    />
  );
}

export { SortPermissionTagsDropdown };
